import { Form } from "react-bootstrap";
import { Dash, Plus } from "react-bootstrap-icons";

export interface AddSubtractProps {
    variant?: string;
    quantity: number;
    set: ( n: number ) => void;
    disabled?: boolean;
}

function safeAdd( n: number, delta: number ) {
    return Math.max( 1, n + delta );
}

export function AddSubtract( props: AddSubtractProps ) {
    const { variant = "primary", quantity, set, disabled = false } = props;

    function setNum( value: string ): void {
        try {
            let val = Math.max( 1, Math.min( 999, parseInt( value ) ) );
            if( val < 1 )
                val = 1;
            if( val > 999 )
                val = 999;
            if( isNaN( val ) )
                val = 1;
            set( val )
        }
        catch {
            // Fallback to 1 if parsing fails
            set( 1 );
        }
    }

    function handleInputFocus( e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement> ): void {
        if (e.target instanceof HTMLInputElement) {
            e.target.select();
        }
    }

    const buttonStyle = {
        width: "36px",
        height: "36px",
        border: "1px solid #dee2e6",
        backgroundColor: disabled ? "#f8f9fa" : "#f8f9fa",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: disabled ? "not-allowed" : "pointer",
        transition: "all 0.15s ease-in-out",
        userSelect: "none" as const,
        opacity: disabled ? 0.7 : 1
    };

    const buttonHoverStyle = {
        backgroundColor: disabled ? "#f8f9fa" : "#e9ecef",
        borderColor: disabled ? "#dee2e6" : "#adb5bd"
    };

    const inputStyle = {
        width: "60px",
        height: "36px",
        textAlign: "center" as const,
        border: "1px solid #dee2e6",
        borderRadius: "16px",
        fontSize: "14px",
        fontWeight: "500",
        margin: "0 8px",
        opacity: disabled ? 0.9 : 1,
        cursor: disabled ? "not-allowed" : "text"
    };

    return (
        <div className="d-flex align-items-center">
            <button
                type="button"
                style={buttonStyle}
                className="btn-outline-secondary"
                onClick={() => !disabled && set(safeAdd(quantity, -1))}
                onMouseEnter={(e) => !disabled && Object.assign(e.currentTarget.style, buttonHoverStyle)}
                onMouseLeave={(e) => !disabled && Object.assign(e.currentTarget.style, { backgroundColor: "#f8f9fa", borderColor: "#dee2e6" })}
                disabled={disabled}
                aria-label="Decrease quantity"
            >
                <Dash size={16} />
            </button>
            
            <Form.Control
                style={inputStyle}
                type="number"
                value={quantity}
                onChange={(e) => !disabled && setNum(e.target.value)}
                onFocus={(e) => !disabled && handleInputFocus(e)}
                disabled={disabled}
                min="1"
                max="999"
                aria-label="Quantity"
            />
            
            <button
                type="button"
                style={buttonStyle}
                className="btn-outline-secondary"
                onClick={() => !disabled && set(safeAdd(quantity, +1))}
                onMouseEnter={(e) => !disabled && Object.assign(e.currentTarget.style, buttonHoverStyle)}
                onMouseLeave={(e) => !disabled && Object.assign(e.currentTarget.style, { backgroundColor: "#f8f9fa", borderColor: "#dee2e6" })}
                disabled={disabled}
                aria-label="Increase quantity"
            >
                <Plus size={16} />
            </button>
        </div>
    );
}